import { IHikingType } from '@apps/Hiking/@types/hiking.types';
import { IRegion } from '@apps/Routes/RoutesList/types';

export interface IOneFriend {
  id: number;
  name: string;
  surname: string;
  photo: string;
  isGirl: boolean;

  statistic: null | {
    hikingCount: number;
    hikingLastDate: Date;
    hikingFirstDate: Date;
    hikingIds: number[];
  };
}

export enum UserAllergiesType {
  Medicament = '1',
  Product = '2',
  Other = '3',
}

export interface IUserAllergies {
  id: number;
  type: UserAllergiesType;
  name: string;
  comment: string;
  product: null | {
    id: number;
    name: string;
  };
  medicament: null | {
    id: number;
    name: string;
  };

  created_at: Date;
  updated_at: Date | null;
}

export interface IUserSubscribeListItem {
  id: number;
  email: string;
  confirm_date: Date | null;
  is_confirmed: boolean;
  is_active: boolean;
  regions: IRegion[];
  types: IHikingType[];
}
